import { iaRa } from 'lib/helpers/utility';

export const validationKeys = {
  allergies: 'allergy',
  familyHistory: 'medical_condition',
  surgicalHistory: 'surgery',
  vaccines: 'vaccine',
  weightLossAdministration: 'medication'
};

export const transformData = ({ data = [], shouldMap = true, validation }) => {
  return iaRa(data)
    .filter(Boolean)
    .filter((row) => (shouldMap ? row?.[validation]?.label?.length > 0 : true));
};

export const cleanAndSetHTML = (htmlContent) => {
  // Remove extra spaces between tags
  const cleanedHTML = htmlContent
    ?.replace(/>\s+</g, '><')
    // Preserve single spaces between words
    .replace(/\s+/g, ' ')
    // Remove spaces before closing tags
    .replace(/\s+>/g, '>')
    // Remove spaces after opening tags
    .replace(/<\s+/g, '<');

  return cleanedHTML;
};

export const isDataReadOnly = ({
  canUserUpdatePatientDocuments = false,
  data = null,
  noteLocked = false
}) => {
  const isDataExisting = Boolean(data?.id);
  const isPatientCreated = data?.createdBy?.isPatient;
  return noteLocked || (isDataExisting && !canUserUpdatePatientDocuments && isPatientCreated);
};

export const isMedicationReadOnly = ({
  canUserUpdatePatientDocuments = false,
  data = null,
  noteLocked = false,
  fromPatientPortal = false
}) => {
  const isVeradigmMedication = Boolean(data?.veradigm_id);
  if (isVeradigmMedication) return true;
  if (fromPatientPortal) return false;
  const isMedicationExisting = Boolean(data?.id);
  const isPatientCreated = data?.created_by === data?.patient_id;

  return noteLocked || (isMedicationExisting && isPatientCreated && !canUserUpdatePatientDocuments);
};
